
export class VMEvent {
    id: number | undefined;
    name: string | undefined;
}
export class Line {
    id: number | undefined;
    name: string | undefined;
}